import "../assets/_tooltip.scss"
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const TooltipTwyny = ({ text, children,className }) => {
    return (
      // <div className={` tooltip-container`} >
      //   {children}
      //   <span className={`${className} tooltip-text` } dangerouslySetInnerHTML={{ __html: text }}/>
      // </div>
       <OverlayTrigger
       placement="top"
       overlay={
         <Tooltip id="tooltip-top" className="custom-tooltip">
          {text}
         </Tooltip>
       }
     >
       <button  type="button" className="link-blue">
       {children}
       </button>
     </OverlayTrigger>
    );
  };
  
  export default TooltipTwyny
  